import { render } from "./Launch.vue?vue&type=template&id=d2441800"
import script from "./Launch.vue?vue&type=script&lang=js"
export * from "./Launch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brian/Desktop/My Jetmall@Lear/Projects/myjetmall-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__